// @flow
import React from 'react'
import { styled } from 'styled-components'
import { OptionalMarkdown } from '@mission.io/question-views'
import classnames from 'classnames'

/**
 * This component is for displaying the text event input during a literacy event.
 * The text event may be annotated if the task is a close reading task. Eventually we will support annotations for all text events.
 * @returns {React$Node}
 */
export function TextEventInput({
	text,
	title,
	className,
}: {
	text: string,
	title?: string,
	className?: string,
}): React$Node {
	return (
		<div className={classnames('h-full flex flex-col', className)}>
			<DivWithStyledScroll className={'p-4 h-full'}>
				{title && <h3 className="text-black w-fit">{title}</h3>}

				<OptionalMarkdown
					className="max-w-6xl"
					interpretAsMarkdown={true}
					disabledComponents={['a', 'img']}>
					{text}
				</OptionalMarkdown>
			</DivWithStyledScroll>
		</div>
	)
}

const DivWithStyledScroll = styled.div`
	overflow-y: scroll;

	&::-webkit-scrollbar {
		width: 8px;
		height: 8px;
	}

	&::-webkit-scrollbar-track {
		border-radius: 8px;
	}

	&::-webkit-scrollbar-thumb {
		border-radius: 8px;
		background: #364984;
	}
`
